import React from "react";
import { FormControlLabel, makeStyles, Switch } from "@material-ui/core";
import useInfo from "../store/hooks/useInfo";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles(() => ({
  formLabel: {
    marginLeft: 2,
  },
}));

export default function ShowAsNormalEmsUserSwitch() {
  const classes = useStyles();
  const { loadingInfo, showAsNormalUser, toggleShowAsNormalUser, initialInfo } =
    useInfo();

  if (initialInfo?.isEmsAdmin !== true) {
    return null;
  }

  if (loadingInfo) {
    return (
      <Skeleton
        width={"100%"}
        height={25}
        variant="rect"
        style={{ marginTop: 12 }}
      />
    );
  }

  return (
    <FormControlLabel
      value="start"
      control={
        <Switch color="primary" defaultChecked={showAsNormalUser === true} />
      }
      label={"Mostrar como un usuario normal"}
      labelPlacement="start"
      className={classes.formLabel}
      onChange={() => toggleShowAsNormalUser()}
    />
  );
}
